import { render } from "./AprobariManager.vue?vue&type=template&id=1d256960&ts=true"
import script from "./AprobariManager.vue?vue&type=script&lang=ts"
export * from "./AprobariManager.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__